import styled from "styled-components";
import colors from "../../../../config/colors";
import fonts from "../../../../config/fonts";
import { isMobile } from "../../../../utils/common";

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile() ? "center" : "space-between"};
  width: 100vw;
  padding: ${isMobile() ? "5px" : "50px 100px"};
  box-sizing: border-box;
  background-color: ${colors.background};
  z-index:30;
  ${isMobile()
    ? `
    position:fixed;
    top:0px;
    left:0px;
    border-bottom:solid 1px ${colors.darkBackground};
    background-color: ${colors.background}cc;
    backdrop-filter:blur(5px);

    `
    : ""}
`;

export const AppIconContainer = styled.div`
  z-index: 10;
`;
export const AppIcon = styled.img`
  height: ${isMobile() ? "40px" : "75px"};
`;
export const HeaderOptions = styled.div`
  display: flex;
  align-items: center;
`;
export const HeaderOption = styled.div`
  font-weight: bold;
  ${fonts.headings};
  margin: ${isMobile() ? "20px" : "0px"} 35px;
  font-size: 20px;
  color: ${colors.darkPrimary};
  transition: all 0.2s ease;
  :hover {
    cursor: pointer;
    color: ${colors.primary};
  }
`;
export const BurgerExpander = styled.img`
  height: 40px;
  width: 40px;
  position: fixed;
  top: 5px;
  left: 5px;
  z-index: 20;
`;
export const SideMenu = styled.div`
  position: fixed;
  top: 0px;
  left: ${(props) => (props.expanded ? "0px" : "-100vw")};
  width: 100vw;
  height: 100vh;
  background-image: linear-gradient(
    145deg,
    ${colors.background}aa,
    ${colors.background}99
  );
  backdrop-filter: blur(5px);
  padding-top: 60px;
  box-sizing: border-box;
  transition: all 0.5s ease;
  z-index:10;
`;
